import React from 'react'
import { EXPERT_USER_CAPABILITIES } from 'shared-constants'
import { getLayoutWithExpertSideNav } from '@expert/components/ExpertLayout'
import { Grid } from 'components/Layout'
import { SideNavPage } from 'components/SideNavPage'
import { ShopNavSection } from 'components/SideNavPage/ShopNavSection'
import { useUserAuth } from 'providers/userAuth'
import { SPACE } from 'Theme'
import { ExpertTeamMemberInviteWidget } from '../ExpertTeamMemberInviteWidget'
import { ConsultationsChartWidget } from './ConsultationsChartWidget'
import { ExpertFavoritesWidget } from './ExpertFavoritesWidget'
import { ExpertReferralWidget } from './ExpertReferralWidget'
import { RevenueChartWidget } from './RevenueChartWidget'
import { TestimonialsWidget } from './TestimonialsWidget'
import { UpcomingSessionsWidget } from './UpcomingSessionsWidget'

const ExpertDashboardContent = () => {
  const { user } = useUserAuth()
  const { capabilities } = user
  const isConsultationCapable = capabilities.includes(
    EXPERT_USER_CAPABILITIES.CONSULTATION
  )
  return (
    <>
      <SideNavPage.Header
        leftElement={() => <SideNavPage.Title>Dashboard</SideNavPage.Title>}
        rightElement={() => <ShopNavSection />}
      />
      <SideNavPage.Content>
        <Grid
          gridTemplateColumns={{ MOBILE: '1fr', DESKTOP: '1fr 1fr' }}
          gridTemplateRows="auto"
          gridGap={SPACE.PX_20}
        >
          {isConsultationCapable && (
            <>
              <UpcomingSessionsWidget />
              <RevenueChartWidget />
            </>
          )}
          <ExpertFavoritesWidget />
          <ExpertReferralWidget />
          <ExpertTeamMemberInviteWidget />
          {isConsultationCapable && (
            <>
              <TestimonialsWidget />
              <ConsultationsChartWidget />
            </>
          )}
        </Grid>
      </SideNavPage.Content>
    </>
  )
}

ExpertDashboardContent.getLayout = getLayoutWithExpertSideNav

export const ExpertDashboard = ExpertDashboardContent
